<template>
  <div>
    <div class="caption">Linie/Kurs {{ absence.line }}</div>
    <FromTo v-if="column.columnName==='line'" :isDisabled="isDisabled" :asChip="false" :column="column" :absence="absence"></FromTo>
    <FromTo v-if="column.columnName==='z9Line'" :isDisabled="isDisabled" :asChip="false" :column="column" :absence="absence"></FromTo>
<!--    <div class="caption">{{ absence.lineP2 ? `Linie/Kurs ${absence.lineP2}` : '' }}</div>-->
<!--    <FromTo :isDisabled="isDisabled" :asChip="false" :column="{ columnName:'fromTo2' }" :absence="absence"></FromTo>-->
  </div>
</template>
<script>
import FromTo from './FromTo.vue';

export default {
  name: 'LineTrack',
  components: {
    FromTo,
  },
  props: {
    column: Object,
    absence: Object,
    isAssignedToDifferentView: Boolean,
    isDisabled: { type: Boolean, default: false },
  },
};
</script>